<template>
  <div class="business-circles" v-if="isTatus">
    <ul class="capital">
      <li
        v-for="(item, index) in tableData"
        :key="index"
        :class="{ active: range.includes(index) }"
      >
        <div class="circles-name">
          <div class="name">{{ item.name }}</div>
          <div>
            {{ item.content }}<span v-if="item.name == '注册资本'"> 万元</span>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { getLocalStorage } from '@utils'
import { getEntOpen } from '@api/businessInformation/index'
export default {
  data() {
    return {
      isTatus: false,
      tableData: [
        { name: '企业名称', content: 'entName' },
        { name: '注册资本', content: 'regCap' },
        { name: '在营状态', content: 'entStatus' },
        { name: '企业类型', content: 'entType' },
        { name: '统一社会信用代码', content: 'creditCode' },
        { name: '成立日期', content: 'openFrom' },
        { name: '法定代表人', content: 'frName' },
        { name: '核准时间', content: 'apprDate' },
        { name: '行业门类名称', content: 'industryPhyName' },
        { name: '经营期限', content: 'openTo' },
        { name: '注册代码', content: 'regNo' },
        { name: '登记机关', content: 'regOrg' },
        { name: '国民经济行业名称（代码）', content: 'industryCode' },
        { name: '所在区域', content: 'province' },
        {
          name: '经营范围',
          content: 'operateScope'
        }
      ],
      range: [0, 13, 14]
    }
  },
  beforeCreate() {},
  created() {
    this.getEntOpens()
  },
  methods: {
    getEntOpens() {
      getEntOpen().then(res => {
        const response = res.data.data
        console.log(response)
        if (response) {
          this.tableData.map(value => {
            Object.keys(response).find(val => {
              if (value.content === val) {
                if (value.content == 'province') {
                  value.content =
                    response['province'] + response['city'] + response['county']
                } else {
                  value.content = response[val] ? response[val] : '-'
                }
              }
            })
          })
        } else {
          this.tableData.map(value => {
            value.content = '-'
          })
        }
        this.isTatus = true
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.business-circles {
  padding: 18px;
  .circles-name {
    margin-bottom: 10px;
    .name {
      color: #999;
      font-size: 12px;
      margin-bottom: 6px;
    }
    div {
      font-weight: 500;
      color: rgba(5, 27, 59, 100);
      font-size: 14px;
      width: 166px;
      overflow: hidden; //超出的文本隐藏
      text-overflow: ellipsis; //溢出用省略号显示
      white-space: nowrap;
    }
  }
  .capital {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    li {
      width: 48%;
      height: 44px;
      margin-bottom: 24px;
    }
    li:nth-child(odd) {
      padding-left: 10px;
      border-left: 1px solid rgba(226, 226, 226, 1);
    }
    .active {
      width: 100%;
      height: auto;
      padding-left: 0 !important;
      border-left: none !important;
      .circles-name {
        div {
          width: auto;
          white-space: pre-wrap;
        }
      }
    }
  }
}
</style>
